import React from 'react';
import { Calendar, Phone } from 'lucide-react';

const Events = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Olá! Gostaria de saber mais sobre o Special B-Day K-Rol & Jonatas no Mirroah Deck Bar dia 28/02! 🎉🎂');
    window.open(`https://wa.me/5521972232170?text=${message}`, '_blank');
  };

  return (
    <section id="eventos" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center space-x-3 mb-4">
            <div className="h-1 w-12 bg-gradient-to-r from-yellow-400 to-pink-500 rounded-full"></div>
            <Calendar className="w-8 h-8 text-pink-500" />
            <div className="h-1 w-12 bg-gradient-to-r from-pink-500 to-orange-500 rounded-full"></div>
          </div>
          <h2 className="font-righteous text-4xl md:text-6xl text-gray-900 mb-4">
            PRÓXIMO EVENTO
          </h2>
          <p className="font-poppins text-xl text-gray-600 max-w-2xl mx-auto">
            Celebração especial no Mirroah Deck Bar - Venha festejar com a gente!
          </p>
        </div>

        {/* Featured Event - Full Width */}
        <div className="max-w-5xl mx-auto mb-12">
          <div className="group relative bg-white rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-all duration-500">
            {/* Event Image - Full Width */}
            <div className="relative w-full h-auto">
              <img
                src="https://customer-assets.emergentagent.com/job_carnival-rio-vibes/artifacts/483c7tco_8F8F5F6C-E3EE-4118-A574-966C3AF30382.png"
                alt="Special B-Day K-Rol & Jonatas"
                loading="eager"
                className="w-full h-auto object-contain"
              />
              
              {/* Date Badge */}
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-6 py-3 rounded-full shadow-xl">
                <div className="flex items-center space-x-3">
                  <Calendar className="w-6 h-6 text-pink-500" />
                  <span className="font-poppins font-bold text-gray-900 text-lg">SÁB 28/02</span>
                </div>
              </div>
            </div>

            {/* Event Info */}
            <div className="p-8 md:p-12">
              <h3 className="font-righteous text-4xl md:text-5xl text-gray-900 mb-4 leading-tight">
                SPECIAL B-DAY
              </h3>
              <p className="font-righteous text-2xl md:text-3xl text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-orange-500 mb-6">
                K-Rol & Jonatas
              </p>
              
              <div className="bg-gradient-to-r from-yellow-50 via-pink-50 to-orange-50 rounded-2xl p-6 mb-6">
                <p className="font-poppins text-lg text-gray-800 leading-relaxed">
                  🎉 <strong>Bora celebrar com a gente!</strong> Dia 28/02 é aniversário dos nossos brothers K-Rol e Jonatas, 
                  e você está mais do que convidado pra essa festa épica no Mirroah Deck Bar! 
                </p>
                <p className="font-poppins text-lg text-gray-800 leading-relaxed mt-3">
                  Vem curtir com a gente à beira-mar, com aquela vibe única, drinks gelados, muita música boa e 
                  aquele pôr do sol de tirar o fôlego! Vai ser massa demais! 🏖️🎂🍹
                </p>
                <p className="font-poppins text-lg text-gray-800 leading-relaxed mt-3">
                  Não fica de fora dessa! Cola no Mirroah e vamos fazer desse aniversário uma festa inesquecível! 
                  Te esperamos lá! 🎊✨
                </p>
              </div>

              <div className="flex flex-wrap gap-3 mb-6">
                <div className="flex items-center space-x-2 bg-gradient-to-r from-yellow-100 to-orange-100 px-4 py-2 rounded-full">
                  <div className="w-3 h-3 bg-orange-500 rounded-full animate-pulse"></div>
                  <span className="font-poppins font-semibold text-gray-800">Evento Especial</span>
                </div>
                <div className="flex items-center space-x-2 bg-gradient-to-r from-pink-100 to-rose-100 px-4 py-2 rounded-full">
                  <div className="w-3 h-3 bg-pink-500 rounded-full animate-pulse"></div>
                  <span className="font-poppins font-semibold text-gray-800">Vista para o Mar</span>
                </div>
                <div className="flex items-center space-x-2 bg-gradient-to-r from-blue-100 to-cyan-100 px-4 py-2 rounded-full">
                  <div className="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
                  <span className="font-poppins font-semibold text-gray-800">Drinks & Petiscos</span>
                </div>
              </div>

              <button
                onClick={handleWhatsAppClick}
                className="w-full mt-6 bg-gradient-to-r from-green-500 to-green-600 text-white font-poppins font-bold py-5 rounded-2xl hover:scale-105 hover:shadow-2xl transition-all duration-300 flex items-center justify-center space-x-3 text-lg"
              >
                <Phone className="w-6 h-6" />
                <span>Confirmar Presença pelo WhatsApp</span>
              </button>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center bg-gradient-to-r from-yellow-400 via-pink-500 to-orange-500 rounded-3xl p-8 md:p-12 shadow-xl">
          <h3 className="font-righteous text-3xl md:text-4xl text-white mb-4">
            Vem Comemorar com a Gente! 🎉
          </h3>
          <p className="font-poppins text-lg text-white/95 mb-6 max-w-2xl mx-auto">
            Aniversário duplo, festa tripla! Garanta sua presença nessa celebração especial à beira-mar.
          </p>
          <button
            onClick={handleWhatsAppClick}
            className="bg-white text-gray-900 font-poppins font-bold px-10 py-5 rounded-full hover:scale-110 hover:shadow-2xl transition-all duration-300 text-lg"
          >
            Falar no WhatsApp
          </button>
        </div>
      </div>
    </section>
  );
};

export default Events;
